export const ConstPlaceHolder = "Ask me anything..."
export const affiliateLink =  "&linkCode=ll1&tag=getproducth03-20&linkId=fcbd442f8590ddacb18741a3c9addaa8&language=en_US&ref_=as_li_ss_tl"

